import { render, staticRenderFns } from "./arv.vue?vue&type=template&id=116bfa37&scoped=true&"
import script from "./arv.vue?vue&type=script&lang=js&"
export * from "./arv.vue?vue&type=script&lang=js&"
import style0 from "./arv.vue?vue&type=style&index=0&id=116bfa37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116bfa37",
  null
  
)

export default component.exports